import React from 'react';
import { smoothScroll } from '../utils/scroll';
import Logo from './Logo';
import './Sidebar.css';

interface SidebarProps {
  isOpen: boolean;
  onClose: () => void;
}

interface MenuItem {
  label: string;
  href: string;
}

const Sidebar: React.FC<SidebarProps> = ({ isOpen, onClose }) => {
  const menuItems: MenuItem[] = [
    { label: '🏠 Home', href: '#home' },
    // { label: '📅 Eventi', href: '#eventi' },
    { label: '👥 Chi Siamo', href: '#chi-siamo' },
    // { label: '📝 Blog', href: '#blog' },
    // { label: '🎟️ Membership', href: '#membership' },
    { label: '📧 Contattaci', href: '#contatti' },
  ];

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string): void => {
    e.preventDefault();
    if (href !== '#blog') {
      smoothScroll(href);
    }
    onClose();
  };

  return (
    <>
      <div className={`overlay ${isOpen ? 'active' : ''}`} onClick={onClose}></div>
      <div className={`sidebar ${isOpen ? 'active' : ''}`}>
        <div className="sidebar-header">
          <Logo />
          <button
            type="button"
            className="sidebar-close"
            onClick={onClose}
            aria-label="Chiudi menu"
          >
            ✕
          </button>
        </div>
        <nav className="sidebar-menu">
          {menuItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              onClick={(e) => handleClick(e, item.href)}
            >
              {item.label}
            </a>
          ))}
        </nav>
      </div>
    </>
  );
};

export default Sidebar;



